<template>

<main class="bg-gray-100 py-12">
        <section>
            <div class="container space-y-8">
                <h1>
                    Datenschutzhinweise
                </h1>
                <p>
                    <strong>§&nbsp;1</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Information über die Erhebung
                    personenbezogener Daten</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Im Folgenden informieren wir über die Erhebung personenbezogener
                    Daten bei Nutzung unserer Website. Personenbezogene Daten sind alle Daten, die auf Sie persönlich
                    beziehbar sind, z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Verantwortlicher gem. Art.&nbsp;4 Abs.&nbsp;7
                    EU-Datenschutz-Grundverordnung (DS-GVO) ist die Sauerland Spielgeräte GmbH, Kamp 7, D-33154
                    Salzkotten, <span><a href="mailto:info@sauerland-spielgeraete.de">info@sauerland-spielgeraete.de</a></span>,
                    +49 (0) 2955 7606 0 (siehe unser Impressum. Unseren Datenschutzbeauftragten erreichen Sie unter
                    <span><a href="mailto:oliver.baldner@bits.gmbh">oliver.baldner@bits.gmbh</a></span>,
                    05251 68 89 48 0 oder unserer Postadresse mit dem Zusatz „der Datenschutzbeauftragte“.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bei Ihrer Kontaktaufnahme mit uns per E-Mail oder über ein
                    Kontaktformular werden die von Ihnen mitgeteilten Daten (Ihre E-Mail-Adresse, ggf. Ihr Name und Ihre
                    Telefonnummer) von uns gespeichert, um Ihre Fragen zu beantworten. Die in diesem Zusammenhang
                    anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken
                    die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.<br>
                    (4) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Falls wir für einzelne Funktionen unseres Angebots auf
                    beauftragte Dienstleister zurückgreifen oder Ihre Daten für werbliche Zwecke nutzen möchten, werden
                    wir Sie untenstehend im Detail über die jeweiligen Vorgänge informieren. Dabei nennen wir auch die
                    festgelegten Kriterien der Speicherdauer.
                </p>
                <p>
                    <strong>§ 2</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Erhebung personenbezogener Daten bei
                    Besuch unserer Website</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bei der bloß informatorischen Nutzung der Website, also wenn Sie
                    sich nicht registrieren oder uns anderweitig Informationen übermitteln, erheben wir nur die
                    personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Wenn Sie unsere Website
                    betrachten möchten, erheben wir die folgenden Daten, die für uns technisch erforderlich sind, um
                    Ihnen unsere Website anzuzeigen und die Stabilität und Sicherheit zu gewährleisten (Rechtsgrundlage
                    ist Art.&nbsp;6 Abs.&nbsp;1 S.&nbsp;1 lit. f DS-GVO):<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; IP-Adresse<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Datum und Uhrzeit der Anfrage<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zeitzonendifferenz zur Greenwich Mean Time
                    (GMT)<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Inhalt der Anforderung (konkrete Seite)<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zugriffsstatus/HTTP-Statuscode<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; jeweils übertragene Datenmenge<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Website, von der die Anforderung kommt<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Browser<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Betriebssystem und dessen Oberfläche<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sprache und Version der Browsersoftware.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Zusätzlich zu den zuvor genannten Daten werden bei Ihrer Nutzung
                    unserer Website Cookies auf Ihrem Rechner gespeichert. Bei Cookies handelt es sich um kleine
                    Textdateien, die auf Ihrer Festplatte dem von Ihnen verwendeten Browser zugeordnet gespeichert
                    werden und durch welche der Stelle, die den Cookie setzt (hier durch uns), bestimmte Informationen
                    zufließen. Cookies können keine Programme ausführen oder Viren auf Ihren Computer übertragen. Sie
                    dienen dazu, das Internetangebot insgesamt nutzerfreundlicher und effektiver zu machen.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Einsatz von Cookies:<br>
                    a) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Diese Website nutzt folgende Arten von Cookies, deren
                    Umfang und Funktionsweise im Folgenden erläutert werden:<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Transiente Cookies (dazu b)<br>
                    –&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Persistente Cookies (dazu c)<br>
                    b) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Transiente Cookies werden automatisiert gelöscht, wenn Sie
                    den Browser schließen. Dazu zählen insbesondere die Session-Cookies. Diese speichern eine sogenannte
                    Session-ID, mit welcher sich verschiedene Anfragen Ihres Browsers der gemeinsamen Sitzung zuordnen
                    lassen. Dadurch kann Ihr Rechner wiedererkannt werden, wenn Sie auf unsere Website zurückkehren. Die
                    Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder den Browser schließen.<br>
                    c) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Persistente Cookies werden automatisiert nach einer
                    vorgegebenen Dauer gelöscht, die sich je nach Cookie unterscheiden kann. Sie können die Cookies in
                    den Sicherheitseinstellungen Ihres Browsers jederzeit löschen.<br>
                    d) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sie können Ihre Browser-Einstellung entsprechend Ihren
                    Wünschen konfigurieren und z. B. die Annahme von Third-Party-Cookies oder allen Cookies ablehnen.
                    Wir weisen Sie darauf hin, dass Sie eventuell nicht alle Funktionen dieser Website nutzen
                    können.<br>
                    &nbsp;<br>
                    <strong>§ 3 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Weitere Funktionen und Angebote unserer
                        Website</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Neben der rein informatorischen Nutzung unserer Website bieten
                    wir verschiedene Leistungen an, die Sie bei Interesse nutzen können. Dazu müssen Sie in der Regel
                    weitere personenbezogene Daten angeben, die wir zur Erbringung der jeweiligen Leistung nutzen und
                    für die die zuvor genannten Grundsätze zur Datenverarbeitung gelten.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Teilweise bedienen wir uns zur Verarbeitung Ihrer Daten externer
                    Dienstleister. Diese wurden von uns sorgfältig ausgewählt und beauftragt, sind an unsere Weisungen
                    gebunden und werden regelmäßig kontrolliert.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Weiterhin können wir Ihre personenbezogenen Daten an Dritte
                    weitergeben, wenn Aktionsteilnahmen, Gewinnspiele, Vertragsabschlüsse oder ähnliche Leistungen von
                    uns gemeinsam mit Partnern angeboten werden. Nähere Informationen hierzu erhalten Sie bei Angabe
                    Ihrer personenbezogenen Daten oder untenstehend in der Beschreibung des Angebotes.<br>
                    (4) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Soweit unsere Dienstleister oder Partner ihren Sitz in einem
                    Staat außerhalb des Europäischen Wirtschaftsraumen (EWR) haben, informieren wir Sie über die Folgen
                    dieses Umstands in der Beschreibung des Angebotes.<br>
                    &nbsp;<br>
                    <strong>§ 4 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Widerspruch oder Widerruf gegen die Verarbeitung Ihrer
                        Daten</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Falls Sie eine Einwilligung zur Verarbeitung Ihrer Daten erteilt
                    haben, können Sie diese jederzeit widerrufen. Ein solcher Widerruf beeinflusst die Zulässigkeit der
                    Verarbeitung Ihrer personenbezogenen Daten, nachdem Sie ihn gegenüber uns ausgesprochen haben.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Soweit wir die Verarbeitung Ihrer personenbezogenen Daten auf die
                    Interessenabwägung stützen, können Sie Widerspruch gegen die Verarbeitung einlegen. Dies ist der
                    Fall, wenn die Verarbeitung insbesondere nicht zur Erfüllung eines Vertrags mit Ihnen erforderlich
                    ist, was von uns jeweils bei der nachfolgenden Beschreibung der Funktionen dargestellt wird. Bei
                    Ausübung eines solchen Widerspruchs bitten wir um Darlegung der Gründe, weshalb wir Ihre
                    personenbezogenen Daten nicht wie von uns durchgeführt verarbeiten sollten. Im Falle Ihres
                    begründeten Widerspruchs prüfen wir die Sachlage und werden entweder die Datenverarbeitung
                    einstellen bzw. anpassen oder Ihnen unsere zwingenden schutzwürdigen Gründe aufzeigen, aufgrund
                    derer wir die Verarbeitung fortführen.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Selbstverständlich können Sie der Verarbeitung Ihrer
                    personenbezogenen Daten für Zwecke der Werbung und Datenanalyse jederzeit widersprechen. Über
                    Ihren Werbewiderspruch können Sie uns unter folgenden Kontaktdaten informieren: Sauerland
                    Spielgeräte GmbH, Kamp 7, D-33154 Salzkotten, E-Mail: <span><a
                        href="mailto:info@sauerland-spielgeraete.de"
                    >info@sauerland-spielgeraete.de</a></span>,
                    Telefon:+49 (0) 2955 7606 0; Telefax:+49 (0) 2955 7606 221).</strong><br>
                    &nbsp;<br>
                    <strong>§ 5 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nutzung unserer Merkzettelfunktion im
                        eProduktkatalog</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wenn Sie in unserem eProduktkatalog nach Anlage eines Kontos über
                    die Merkzettelfunktion ein unverbindliches individuelles Angebot anfordern möchten, ist es
                    erforderlich, dass Sie Ihre persönlichen Daten bzw. die Daten Ihres Unternehmens angeben, die wir
                    für die Angebotserstellung und –übersendung benötigen. Für die Angebotserstellung und -übersendung
                    notwendige Pflichtangaben sind gesondert markiert, weitere Angaben sind freiwillig. Die von Ihnen
                    angegebenen Daten verarbeiten wir zur Erstellung und Übersendung des von Ihnen angeforderten
                    individuellen Angebots. Rechtsgrundlage hierfür ist Art.&nbsp;6 Abs.&nbsp;1 S.&nbsp;1 lit. b DS-GVO.<br>
                    Für die Nutzung der Merkzettelfunktion im eProduktkatalog können Sie ändern, indem Sie Ihre Daten
                    für die Angebotsanforderungen speichern. Bei Anlegung eines Accounts unter „Mein Konto“ werden die
                    von Ihnen angegebenen Daten widerruflich gespeichert. Alle weiteren Daten, inklusive der auf dem
                    Merkzettel notierten Produkte, können Sie im Konto jederzeit löschen. Des Weiteren haben Sie im
                    Konto die Möglichkeit, Ihr Passwort zu ändern und unseren Newsletter zu abonnieren.<br>
                    Wir können die von Ihnen angegebenen Daten zudem verarbeiten, um Sie über weitere interessante
                    Produkte aus unserem Portfolio zu informieren oder Ihnen E-Mails mit technischen Informationen
                    zukommen lassen. Rechtsgrundlage hierfür ist Art.&nbsp;6 Abs.&nbsp;1 S.&nbsp;1 lit. f DS-GVO.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wir sind im Falle eines Vertragsabschlusses im Zusammenhang mit
                    einer Angebotsübersendung aufgrund handels- und steuerrechtlicher Vorgaben verpflichtet, Ihre
                    Adress- und Angebotsanforderungsdaten für die Dauer von zehn Jahren zu speichern. Allerdings nehmen
                    wir nach zwei Jahren eine Einschränkung der Verarbeitung vor, d. h. Ihre Daten werden nur zur
                    Einhaltung der gesetzlichen Verpflichtungen eingesetzt.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Um unberechtigte Zugriffe Dritter auf Ihre persönlichen Daten zu
                    verhindern, wird die Verbindung per SSL-Technik verschlüsselt.<br>
                    &nbsp;<br>
                    <strong>§ 6 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Newsletter</strong><br>
                    (1) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mit Ihrer Einwilligung können Sie unseren Newsletter abonnieren,
                    in dem wir Sie über unsere eigenen Produkte und Dienstleistungen sowie über wichtige rechtliche und
                    tatsächliche Aspekte zum Betreiben eines Spielplatzes informieren.<br>
                    (2) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Für die Anmeldung zu unserem Newsletter verwenden wir das sog.
                    Double-opt-in-Verfahren. Das heißt, dass wir Ihnen nach Ihrer Anmeldung eine E-Mail an die
                    angegebene E-Mail-Adresse senden, in welcher wir Sie um Bestätigung bitten, dass Sie den Versand des
                    Newsletters wünschen. Wenn Sie Ihre Anmeldung nicht innerhalb von 24 Stunden bestätigen, werden Ihre
                    Informationen gesperrt und nach einem Monat automatisch gelöscht. Darüber hinaus speichern wir
                    jeweils Ihre eingesetzten IP-Adressen und Zeitpunkte der Anmeldung und Bestätigung. Zweck des
                    Verfahrens ist, Ihre Anmeldung nachweisen und ggf. einen möglichen Missbrauch Ihrer persönlichen
                    Daten aufklären zu können.<br>
                    (3) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Pflichtangabe für die Übersendung des Newsletters ist allein Ihre
                    E-Mail-Adresse. Nach Ihrer Bestätigung speichern wir Ihre E-Mail-Adresse zum Zweck der Zusendung des
                    Newsletters. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. a DS-GVO.<br>
                    (4) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ihre Einwilligung in die Übersendung des Newsletters können Sie
                    jederzeit widerrufen und den Newsletter abbestellen. Den Widerruf können Sie durch Klick auf den in
                    jeder Newsletter-E-Mail bereitgestellten Link oder per E-Mail an <span><a
                    href="mailto:info@sauerland-spielgeraete.de"
                >info@sauerland-spielgeraete.de</a></span>,
                    oder durch eine Nachricht an die im Impressum angegebenen Kontaktdaten erklären.<br>
                    (5) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Wir weisen Sie darauf hin, dass wir bei Versand des Newsletters
                    Ihr Nutzerverhalten auswerten. Für diese Auswertung beinhalten die versendeten E-Mails sogenannte
                    Web-Beacons bzw. Tracking-Pixel, die Ein-Pixel-Bilddateien darstellen. Für die Auswertungen werden
                    Zeitpunkt und IP-Adresse gespeichert, wenn Sie den Newsletter öffnen oder einen Link in unserem
                    Newsletter anklicken und diese Daten Ihrer E-Mail-Adresse zugordnet.
                </p>
                <p>
                    Ein solches Tracking ist nicht möglich, wenn Sie in Ihrem E-Mail-Programm die Anzeige von Bildern
                    standardmäßig deaktiviert haben. In diesem Fall wird Ihnen der Newsletter nicht vollständig
                    angezeigt und Sie können eventuell nicht alle Funktionen nutzen. Wenn Sie die Bilder manuell
                    anzeigen lassen oder einen im Newsletter enthaltenen Link anklicken, erfolgt das oben genannte
                    Tracking.<br>
                    &nbsp;<br>
                    <strong>§ 7 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> <strong>Google Analytics</strong><br>
                    Wir nutzen auf unserer Webseite das Tool Google Analytics, welches durch das Unternehmen Google LLC
                    angeboten und betrieben wird.
                </p>
                <p>
                    Die Geschäftsadresse der Google LLC: 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Das
                    Impressum der Google LLC mit weiterführenden Informationen kann unter folgendem Link abgerufen
                    werden:
                    <a
                        target="_blank"
                        href="https://www.google.com/intl/de_de/+/policy/imprint.html"
                    >
                        https://www.google.com/intl/de_de/+/policy/imprint.html
                    </a>
                </p>
                <p>
                    Die Geschäftsadresse des zuständigen Dienstanbieters in der EU ist die Google Ireland Limited,
                    Gordon
                    House, Barrow Street, Dublin 4, Irland. Das Impressum der Google Ireland Limited mit weiterführenden
                    Informationen kann unter dem folgenden Link abgerufen werden:
                    <a
                        target="_blank"
                        href="https://www.google.de/intl/de/contact/impressum.html"
                    >
                        https://www.google.de/intl/de/contact/impressum.html
                    </a>
                </p>
                <p>
                    Die Nutzung des Tools durch uns erfolgt nur, soweit Sie in die Nutzung dieses Dienstes eingewilligt
                    haben.<br>
                    Das Tool Google Analytics dient der Analyse der Nutzung unserer Webseiten durch Sie
                    (Webanalysedienst).<br>
                    Um die Analysen durchführen zu können und die Funktion des Tools zu gewährleisten, haben wir den
                    Code, der die Funktion von Google Analytics sicherstellt, auf unserer Website, die Sie besuchen,
                    implementiert.<br>
                    In unserem Auftrag wird Google die auf der Website erfassten Informationen benutzen, um Ihre
                    (grundsätzlich pseudonyme) Nutzung der Website auszuwerten und um Reports über die
                    Website-Aktivitäten zusammenzustellen. Die durch Google Analytics bereitgestellten Reports dienen
                    der Analyse der Leistung unserer Website.<br>
                    Google Analytics verwendet zur Analyse der Benutzung unserer Webseiten durch Sie sog. Cookies. Bei
                    den Cookies handelt es sich um kleine Text-Dateien, die an Ihren Browser gesendet und auf dem
                    Datenträger Ihres Geräts gespeichert werden.<br>
                    Um Ihre Privatsphäre zu schützen, anonymisieren wir die IP-Adressen, die an Google übertragen
                    werden, indem wir die Funktion ‘anonymizeIP’ (sog. IP-Masking) einsetzen: Aufgrund der Aktivierung
                    der IP-Anonymisierung auf dieser Webseite wird Ihre IP-Adresse von Google innerhalb von
                    Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den
                    Europäischen Wirtschaftsraum gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen
                    Server von Google in den USA übertragen und dort gekürzt. Die im Rahmen von Google Analytics von
                    Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.<br>
                    Als Auftragsverarbeiter verarbeitet Google Ireland Limited Ihre personenbezogenen Daten in unserem
                    Auftrag. Hierfür haben wir mit Google einen Auftragsverarbeitungsvertrag gem. Art. 28 DS-GVO
                    abgeschlossen. Im Rahmen der Auftragsverarbeitung ist Google zur Beauftragung von Subunternehmern
                    berechtigt. Eine Liste der genehmigten Subunternehmer können Sie abrufen unter: <a
                    target="_blank"
                    href="https://privacy.google.com/businesses/subprocessors/"
                >https://privacy.google.com/businesses/subprocessors/</a>. Neben der Google LLC mit Sitz in den USA
                    können ggf. die US-amerikanischen Behörden auf die bei Google gespeicherten Daten zugreifen.<br>
                    Soweit Cookies im Rahmen der Nutzung von Google Analytics eingesetzt werden, werden diese durch
                    Google ausführlich beschrieben.
                </p>
                <p>
                    Allgemeine Ausführungen zu den eingesetzten Cookies sind abrufbar unter: <a
                    target="_blank"
                    href="https://policies.google.com/technologies/types?hl=de"
                >https://policies.google.com/technologies/types?hl=de</a><br>
                    Detaillierte Ausführungen zu den eingesetzten Cookies, insb. bzgl. der in diesem Zusammenhang
                    verarbeiteten personenbezogenen Daten, der Speicherdauer der einzelnen Cookies sowie ihrer Zwecke
                    sind abrufbar unter:<br>
                    <a
                        target="_blank"
                        href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de"
                    >https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=de</a>
                </p>
                <p>
                    Um allgemein mehr über die Datenschutzbestimmungen von Google zu erfahren, können Sie unter dem
                    folgenden Link diese Bestimmungen abrufen:<br>
                    <a
                        target="_blank"
                        href="https://policies.google.com/privacy?hl=de#infocollect"
                    >https://policies.google.com/privacy?hl=de#infocollect</a><br>
                    Die Rechtsgrundlage für den Einsatz von Google Analytics ist Ihre Einwilligung nach Art. 6 Abs. 1
                    lit. a) DS-GVO. Ihre Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden,
                    indem Sie die Cookie-Einstellungen unter dem folgenden Link ändern:<br>
                    <a
                        onclick="if( typeof cookieconsent === 'object' ) { cookieconsent.showBanner(); return false; }"
                        href="?cookieconsent=true"
                        rel="nofollow"
                    >Cookie-Einstellungen</a>
                </p>
                <p>
                    Sie können die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen
                    Daten verhindern, indem Sie Ihre Einwilligung in das Setzen des entsprechenden Cookies nicht
                    erteilen oder das Browser-Add-on zur Deaktivierung von Google Analytics installieren. Dieses ist
                    abrufbar unter:<br>
                    <a
                        target="_blank"
                        href="https://tools.google.com/dlpage/gaoptout?hl=de"
                    >https://tools.google.com/dlpage/gaoptout?hl=de</a><br>
                    Sie können das Setzen von Cookies auch durch eine entsprechende Einstellung Ihres Browsers
                    verhindern, indem Sie Ihren Browser so konfigurieren, dass alle Cookies abgelehnt werden. In diesem
                    Fall kann es jedoch zur Einschränkung der Funktionalitäten auf dieser und anderen Websites
                    kommen.<br>
                    Soweit die erfassten Daten bzgl. der Benutzeraktivitäten durch Google Ireland Limited an die Google
                    LLC (Muttergesellschaft in den USA), übermittelt werden, erfolgt die Übermittlung ebenfalls aufgrund
                    Ihrer Einwilligung gem. Art. 49 Abs. 1 lit. a DS-GVO i.V.m. Art. 6 Abs. 1 lit. a) DS-GVO.<br>
                    &nbsp;<br>
                    <strong>§ 8 &nbsp;&nbsp; Verwendung der APP 3D-Planer Sauerland Spielgeräte GmbH<br></strong>Wie
                    bieten die App 3D-Planer zur Verwendung auf Smartphones, Tablets oder sonstigen Endgeräten &nbsp;mit
                    den Betriebssystemen Android und iOS an. Der Zweck der App ist die erweiterte Darstellung von 3D
                    Modellen unserer Produkte. Wird der Zugriff auf die Kamera von Anwender genehmigt, werden die 3D
                    Modelle in die von der Kamera erfassten Umgebung eingeblendet (erweiterte Realität). Rechtsgrundlage
                    der Datenverarbeitung ist unser berechtigtes Interesse, Ihnen unsere Produkte möglichst realitätsnah
                    in der geplanten Umgebung präsentieren zu können (Art. 6 Abs. 1 lit. f DS-GVO).
                </p>
                <p>
                    Im Rahmen der Installation der App werden gegebenenfalls Ihre personenbezogenen Daten von den
                    Betreibern der Stores (Apple bzw. Google) verarbeitet. Hierauf haben wir als Hersteller und Anbieter
                    der App keinen Einfluss und können Sie daher nur auf die jeweiligen Datenschutzhinweise der
                    Betreiber verweisen.
                </p>
                <p>Eine Weiterleitung Ihrer Daten erfolgt nicht.</p>
                <p>
                    Die Darstellung erfolgt ausschließlich auf Ihrem Endgerät. Zur Darstellung der Umgebung benötigt die
                    App Zugriff auf die Kamera. Das 3D Modell unserer Produkte können Sie vorab auf Ihr Endgerät
                    herunterladen. Für den Zugriff auf die gespeicherte Datei des 3D Modells benötig die App den Zugriff
                    auf die entsprechende Datei bzw. den entsprechenden Ordner. Sie können die gewährten Zugriffsrechte
                    jederzeit in den Einstellungen Ihres Endgeräts zurücksetzen.<br>
                    <br>
                </p>
                <p><strong>§ 9 &nbsp;&nbsp; Verwendung von YouTube Videos</strong></p>
                <p>
                    Wir nutzen auf unserer Seite Videos, die auf dem Internet-Videoportal YouTube (abrufbar unter: <a
                    href="https://www.YouTube.com"
                >https://www.YouTube.com</a>) gespeichert sind.
                </p>
                <p>
                    Das Internet-Videoportal YouTube wird von einer US-amerikanischen Gesellschaft, der YouTube LLC
                    bereitgestellt (LLC steht für Limited Liability Company; zu deutsch: Unternehmen mit beschränkter
                    Haftung). Die Geschäftsadresse der YouTube LLC: 901 Cherry Ave., San Bruno, CA 94066, USA. Die
                    YouTube LLC ist ihrerseits ein Tochterunternehmen der in Irland ansässigen Gesellschaft Google
                    Ireland Limited. Die Geschäftsadresse der Google Ireland Limited: Gordon House, Barrow Street,
                    Dublin 4, Irland (Google).
                </p>
                <p>
                    Die Nutzung der Videos erfolgt dadurch, dass wir ein Video auf unserer Seite einbetten, indem ein
                    externer Videoplayer von YouTube eingebunden wird. Beim Anklicken des Videos wird dieses direkt auf
                    unserer Seite abgespielt.
                </p>
                <p>
                    Durch die Anwendung dieser Technologie werden personenbezogene Daten an YouTube LLC übermittelt, so
                    wie es im Folgenden beschrieben wird.
                </p>
                <p>
                    Die Videos werden auf unserer Website so eingebunden, dass keine personenbezogenen Daten an die
                    YouTube LLC übertragen werden, wenn Sie Ihre Einwilligung in die Nutzung dieses Dienstes nicht
                    erteilt haben.
                </p>
                <p>
                    Wenn Sie das Video auf dem YouTube-Videoportal aufrufen, verarbeitet die YouTube LLC Ihre
                    personenbezogenen Daten (z.B. Ihre IP-Adresse, Standortdaten ihres Geräts, Sensordaten von Ihrem
                    Gerät, WLAN-Zugriffspunkte etc.) gemäß der eigenen Datenschutzerklärung, die Sie unter dem folgenden
                    Link abrufen können: <a href="https://policies.google.com/privacy?hl=de&amp;gl=de">https://policies.google.com/privacy?hl=de&amp;gl=de</a>.
                </p>
                <p>
                    Wenn Sie sich die auf unserer Seite eingebetteten Videos anschauen, werden durch den Diensteanbieter
                    YouTube Cookies verwendet, um Anzeigen für Nutzer ansprechender und für Publisher und Werbetreibende
                    wertvoller zu gestalten. Für gewöhnlich werden Cookies verwendet, um nutzerrelevante Anzeigen
                    auszuwählen, die Berichterstellung zur Kampagnenleistung zu verbessern oder um zu vermeiden, dass
                    ein Nutzer die gleichen Anzeigen mehrmals sieht.
                </p>
                <p>
                    Eine solche Datenerhebung durch YouTube kann auch bei Besuchern dieser Website erfolgen, die nicht
                    bei YouTube eingeloggt oder registriert sind. YouTube nutzt und verarbeitet die Daten der Nutzer im
                    Regelfall – wie ausgeführt – für Marktforschungs- und Werbezwecke. So lassen sich beispielsweise aus
                    dem Nutzungsverhalten und den sich daraus ergebenden Interessen der User Nutzungsprofile erstellen.
                    Die Nutzungsprofile können ihrerseits verwendet werden, um beispielsweise Werbeanzeigen innerhalb
                    und außerhalb von YouTube zu schalten, die den mutmaßlichen Interessen der Nutzer entsprechen. Zu
                    diesen Zwecken werden im Regelfall Cookies auf den Rechnern der User gespeichert, in denen das
                    Nutzungsverhalten und die Interessen der Nutzer gespeichert werden.
                </p>
                <p>
                    Bei den Cookies handelt es sich um kleine Text-Dateien, die an Ihren Browser gesendet und auf dem
                    Datenträger Ihres Geräts gespeichert werden. Diese Cookies ermöglichen es dem Dienst YouTube bzw.
                    Google, Ihre Nutzerdaten (z.B. URL, Referrer-URL, IP-Adresse, Geräte- und Browsereigenschaften (User
                    Agent) sowie Zeitstempel) mit den Daten Ihres ggf. vorhandenen Google-Kontos abzugleichen.
                </p>
                <p>
                    Ferner können in den Nutzungsprofilen auch Daten unabhängig der von den Nutzern verwendeten Geräte
                    gespeichert werden (insbesondere dann, wenn die Nutzer YouTube-Mitglieder sind und auf der
                    YouTube-Seite eingeloggt sind).
                </p>
                <p>
                    Die durch YouTube erhobenen Daten sind für uns als Nutzer des Dienstes anonym und nicht einsehbar.
                    Diese Daten werden durch YouTube nur im Rahmen der Zwecke, die in der Datenschutzerklärung von
                    YouTube beschrieben sind, genutzt, z.B. zur Schaltung von Werbeanzeigen. Folgende Informationen
                    werden hier beispielsweise durch YouTube uns als Dienstnutzern zur Verfügung gestellt: Follower,
                    Reichweite, Demographie der Nutzer. Diese Statistiken lassen keinerlei Rückschlüsse auf individuelle
                    Nutzer zu. Auskünfte über Informationen zu persönlichen Daten können daher nur direkt über YouTube
                    abgefragt werden. Wir können unsererseits lediglich die öffentlichen Informationen der Nutzer
                    einsehen, welche durch den jeweiligen YouTube-Nutzer in den privaten Account-Einstellungen durch ihn
                    festgelegt wurden. Die angemeldeten Nutzer haben zudem die Möglichkeit, Likes aktiv zu verbergen
                    oder unserem Kanal nicht mehr zu folgen.
                </p>
                <p>
                    Im Fall, wenn Sie ein angemeldetes YouTube-Mitglied sind und sich auf der YouTube-Seite eingeloggt
                    haben, werden Ihre Daten beim Besuch unserer Seite durch YouTube automatisch Ihrem Benutzerkonto
                    zugeordnet.
                </p>
                <p>
                    Nähere Informationen zu den möglichen Account-Einstellungen auf YouTube sind unter dem folgenden
                    Link
                    zu finden: <a href="https://www.youtube.com/account_privacy">https://www.youtube.com/account_privacy</a>.
                </p>
                <p>
                    Insbesondere können Sie, soweit Sie nicht über einen YouTube-Account verfügen, das Setzen von
                    Cookies
                    auch durch eine entsprechende Einstellung Ihres Browsers verhindern, indem Sie Ihren Browser so
                    konfigurieren, dass alle Cookies abgelehnt werden. In diesem Fall kann es jedoch zur Einschränkung
                    der Funktionalitäten auf dieser und anderen Websites kommen.<br>
                    <br>
                    Soweit Cookies durch YouTube bzw. Google im Rahmen der Nutzung von YouTube eingesetzt werden, werden
                    diese durch YouTube bzw. Google in einer ausführlichen Tabelle, die Sie unter dem folgenden Link
                    abrufen können, beschrieben:<br>
                    <br>
                    <a href="https://policies.google.com/technologies/types">https://policies.google.com/technologies/types</a>
                </p>
                <p>
                    Angemeldete und eingeloggte YouTube-Mitglieder haben die Möglichkeit, über die
                    Videokommentierungsfunktion öffentlich Kontakt mit uns aufzunehmen. Dies erfolgt durch einen
                    öffentlichen Kommentar auf unserem YouTube-Unternehmenskanal. Die persönliche Kontaktaufnahme
                    basiert auf einer freiwilligen Entscheidung der jeweiligen Nutzer und geht stets vom jeweiligen
                    Nutzer aus.
                </p>
                <p>
                    Die Rechtsgrundlage für die Nutzung des YouTube-Dienstes ist Ihre Einwilligung nach Art. 6 Abs. 1
                    lit. a) DS-GVO.
                </p>
                <p>
                    Soweit die erfassten Daten bzgl. der Benutzeraktivitäten durch den Dienstanbieter YouTube LLC in die
                    USA übermittelt werden, erfolgt die Übermittlung ebenfalls aufgrund Ihrer Einwilligung gem. Art. 49
                    Abs. 1 lit. a DS-GVO i.V.m. Art. 6 Abs. 1 lit. a) DS-GVO.
                </p>
                <p><strong>§ 10 &nbsp;&nbsp; Unsere YouTube-Unternehmensseite</strong></p>
                <p>
                    Für die Verarbeitung personenbezogener Daten auf unserer YouTube-Unternehmensseite ist grundsätzlich
                    die YouTube LLC bzw. die Muttergesellschaft Google Ireland Limited allein Verantwortlicher. Weitere
                    Hinweise über die Verarbeitung personenbezogener Daten durch die YouTube LLC bzw. Google erhalten
                    Sie unter <a href="https://policies.google.com/privacy?hl=de&amp;gl=de">https://policies.google.com/privacy?hl=de&amp;gl=de</a>.
                </p>
                <p>
                    Wenn Sie unsere YouTube-Unternehmensseite besuchen, verarbeitet YouTube personenbezogene Daten, um
                    uns in anonymisierter Form Auswertungen zur Verfügung zu stellen. Wir erhalten keine
                    personenbezogenen Daten von Ihnen, sondern haben nur auf die aggregierten Inhalte Zugriff. Auch wenn
                    wir keinen Einfluss auf Art und Umfang der Verarbeitung Ihrer personenbezogenen Daten durch YouTube
                    haben, erfolgt diese Verarbeitung personenbezogener Daten im Rahmen einer gemeinsamen
                    Verantwortlichkeit gemäß Art. 26 DS-GVO. Die Verarbeitung dient dem berechtigten Interesse gemäß
                    Art. 6 Abs. 1 lit. f DS-GVO, Informationen über die Handlungen auf unserer YouTube-Unternehmensseite
                    zu erhalten.
                </p>
                <p>
                    Im Falle von Auskunftsanfragen und der Geltendmachung von Nutzerrechten, wird drauf hingewiesen,
                    dass
                    diese am effektivsten direkt gegenüber Google geltend gemacht werden können, denn nur Google hat
                    Zugriff auf die Daten der Nutzer und kann direkt entsprechende Maßnahmen ergreifen und Auskünfte
                    geben.
                </p>
                <p>
                    Bitte beachten Sie, dass personenbezogene Daten durch YouTube LLC auch in den USA verarbeitet
                    werden.<br>
                    <br>
                </p>

                <div class="space-y-4">
                    <p>
                        <strong>§ 11</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Unsere Präsenz auf
                        Facebook</strong>
                    </p>
                    <p>
                        Unter dem folgenden Link erreichen Sie unsere Facebook-Seite, für die wir bei bestimmten
                        Funktionen
                        (s.u.) gemeinsam mit der Meta Platforms Ireland Limited mit Sitz in Dublin (Irland) gemäß Art.
                        26
                        DS-GVO verantwortlich sind:
                    </p>
                    <p>
                        <a
                            target="_blank"
                            href="https://www.facebook.com/sauerlandspielgeraete"
                        >https://www.facebook.com/sauerlandspielgeraete</a>
                    </p>
                    <p>
                        Die Meta Platforms Ireland Limited ist ein Tochterunternehmen der Meta Platforms, Inc. (ehemals
                        Facebook Inc.) mit Sitz in Menlo Park, Kalifornien, USA (Meta Platforms).
                    </p>
                    <p>
                        Soweit Sie unsere oben angegebene Facebook-Seite besuchen, erfasst Meta Platforms u.a. Ihre
                        IP-Adresse sowie weitere Informationen, die Meta Platforms in Form von Cookies auf Ihrem PC
                        abspeichert, um uns als Betreiber der Facebook-Seiten statistische Informationen über die
                        Inanspruchnahme der Facebook-Seite zur Verfügung zu stellen.
                    </p>
                    <p>
                        Nähere Informationen zur Datenverarbeitung in diesem Zusammenhang stellt Meta Platforms unter
                        folgendem Link zur Verfügung: <a href="https://de-de.facebook.com/help/pages/insights">https://de-de.facebook.com/help/pages/insights</a>.
                    </p>
                    <p>
                        In gemeinsamer Verantwortlichkeit gemäß Art. 26 DS-GVO mit Meta Platforms wird analysiert, wie
                        Sie
                        unsere Fanpage nutzen (Funktion Seiten-Insights). Die nach der DS-GVO zur Verfügung zu
                        stellenden
                        Informationen zu der Datenverarbeitung im Rahmen von Seiten-Insights hält Meta Platforms unter
                        dem
                        Link bereit: <a href="https://www.facebook.com/privacy/explanation">https://www.facebook.com/privacy/explanation</a>.
                    </p>
                    <p>
                        Meta Platforms stellt Ihnen auch die relevanten Inhalte der zwischen Meta Platforms und uns
                        geschlossenen Vereinbarung über die Verarbeitung in gemeinsamer Verantwortlichkeit nach Art. 26
                        DS-GVO unter folgendem Link zur Verfügung: <a
                        href="https://www.facebook.com/legal/terms/page_controller_addendum"
                    >https://www.facebook.com/legal/terms/page_controller_addendum</a>.
                    </p>
                    <p>
                        Meta Platforms Ireland Limited hat zugestimmt, die primäre Verantwortung gemäß DS-GVO für die
                        Verarbeitung von Insights-Daten zu übernehmen und sämtliche Pflichten aus der DS-GVO im Hinblick
                        auf
                        die Verarbeitung von Insights-Daten zu erfüllen. Dies betrifft insbesondere die Art. 12 und 13
                        DS-GVO, Art. 15 bis 22 DS-GVO und Art. 32 bis 34 DSGVO.
                    </p>
                    <p>
                        Die uns übermittelten statistischen Informationen stellen für uns keine personenbezogenen Daten
                        (mehr) dar, so dass es uns nicht möglich ist, Sie anhand dieser Daten zu identifizieren. Die
                        Statistikdaten nutzen wir nur insofern, als dass wir allgemein die Interessen unserer Nutzer
                        besser
                        verstehen möchten, um unsere Onlinepräsenz zu verbessern und die Qualität unserer Onlineangebote
                        zu
                        sichern.
                    </p>
                    <p>
                        Soweit wir Ihre personenbezogenen Daten über unsere Facebook-Seite erheben (z.B. Ihren Namen,
                        Ihr
                        Nickname, Inhalte der an uns geschickten Nachrichten, Kommentarinhalte sowie die von Ihnen
                        „öffentlich“ bereitgestellten Profilinformationen) nur, um mit Ihnen zu kommunizieren und zu
                        interagieren.
                    </p>
                    <p>
                        Ihre personenbezogenen Daten werden von uns grundsätzlich zum Zweck der Kommunikation und
                        Interaktion
                        auf der Grundlage unseres berechtigten Interesses gem. Art. 6 Abs. 1 lit. f DS-GVO verarbeitet.
                        Unser berechtigtes Interesse besteht darin, dass wir durch unsere Informations- und
                        Kommunikationsangebote auf der Facebook-Seite unsere betriebswirtschaftlichen Ziele verfolgen.
                    </p>
                    <p>
                        Soweit wir im Zusammenhang mit dem Betrieb unserer Facebook-Seite Verarbeitungen durchführen,
                        für
                        die
                        Ihre Einwilligung erforderlich ist (z.B. Teilnahme an einem Gewinnspiel, Verlosung, Versand
                        eines
                        Newsletters, etc.), wird diese unsererseits jeweils separat eingeholt. Die Verarbeitung Ihrer
                        personenbezogenen Daten erfolgt in diesem Fall auf der Grundlage der Art. 6 Abs. 1 lit. a i.V.m.
                        Art. 7 DS-GVO.
                    </p>
                    <p>
                        Soweit das soziale Netzwerk Facebook ihre Daten für seine eigenen Zwecke erhebt, für die eine
                        Einwilligung erforderlich ist (z.B. Auswertung des Nutzerverhaltens), erfolgt dies ebenfalls auf
                        der
                        Grundlage der Art. 6 Abs. 1 lit. a i.V.m. Art. 7 DS-GVO. In diesem Fall wird die erforderliche
                        Einwilligung durch das soziale Netzwerk selbst eingeholt.
                    </p>
                    <p>
                        Aufgrund der gemeinsamen Verantwortlichkeit von Meta Platforms und uns für die Verarbeitung
                        personenbezogener Daten auf unserer Facebook-Präsenz, können Sie Ihre Betroffenenrechte sowohl
                        bei
                        uns als auch direkt bei Meta Platforms geltend machen.
                    </p>
                    <p>
                        Da Meta Platforms für den überwiegenden Teil der stattfindenden Datenverarbeitung als
                        Service-Anbieter verantwortlich ist, sind unsere Möglichkeiten, auf Ihre Daten zuzugreifen, sehr
                        beschränkt. Einen Vollzugriff auf Ihre Daten hat lediglich der Service-Anbieter gemäß den
                        Nutzungsbedingungen des Netzwerks. Aus diesem Grund, kann meistens nur der Anbieter des sozialen
                        Netzwerks die notwendigen Maßnahmen zur Erfüllung Ihrer Betroffenenrechte (z.B. Recht auf
                        Auskunft,
                        Löschung, Widerspruch, etc.) ergreifen und umsetzen. Die Geltendmachung entsprechender Rechte
                        erfolgt somit am effektivsten direkt gegenüber dem Netzwerk-Anbieter.
                    </p>
                    <p>
                        Bitte beachten Sie, dass personenbezogene Daten durch Meta Platforms auch in den USA verarbeitet
                        werden.<br>
                    </p>
                </div>

                <p><strong>§ 12 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Unsere Präsenz auf Instagram</strong></p>
                <p>
                    Unter dem folgenden Link erreichen Sie unsere Instagram-Seite, für die wir bei bestimmten Funktionen
                    (s.u.) mit der Meta Platforms Ireland Limited (Dienstanbieter) mit Sitz in Dublin (Irland) gemäß
                    Art. 26 DS-GVO verantwortlich sind:
                </p>
                <p>
                    <a
                        target="_blank"
                        href="https://www.instagram.com/sauerland_spielgeraete/"
                    >https://www.instagram.com/sauerland_spielgeraete/</a>
                </p>
                <p>
                    Die Meta Platforms Ireland Limited ist ein Tochterunternehmen der Meta Platforms, Inc. (ehemals
                    Facebook Inc.) mit Sitz in Menlo Park, Kalifornien, USA (Meta Platforms).
                </p>
                <p>
                    Soweit Sie unsere oben angegebene Instagram-Seite besuchen, erfasst Meta Platforms u.a. Ihre
                    IP-Adresse sowie weitere Informationen, die Meta Platforms in Form von Cookies auf Ihrem PC
                    abspeichert, um uns als Betreiber der Instagram-Seiten statistische Informationen über die
                    Inanspruchnahme der Instagram-Seite zur Verfügung zu stellen.
                </p>
                <p>
                    Nähere Informationen zur Datenverarbeitung in diesem Zusammenhang stellt Meta Platforms unter
                    folgendem Link zur Verfügung: <a href="https://de-de.facebook.com/help/pages/insights">https://de-de.facebook.com/help/pages/insights</a>.
                </p>
                <p>
                    In gemeinsamer Verantwortlichkeit gemäß Art. 26 DS-GVO mit Meta Platforms wird analysiert, wie Sie
                    unsere Instagram-Seite nutzen (Funktion Seiten-Insights). Die nach der DS-GVO zur Verfügung zu
                    stellenden Informationen zu der Datenverarbeitung im Rahmen von Seiten-Insights hält Meta Platforms
                    unter dem Link bereit: <a href="https://www.facebook.com/privacy/explanation">https://www.facebook.com/privacy/explanation</a>.
                </p>
                <p>
                    Meta Platforms stellt Ihnen auch die relevanten Inhalte der zwischen Meta Platforms und uns
                    geschlossenen Vereinbarung über die Verarbeitung in gemeinsamer Verantwortlichkeit nach Art. 26
                    DS-GVO unter folgendem Link zur Verfügung: <a
                    href="https://www.facebook.com/legal/terms/page_controller_addendum"
                >https://www.facebook.com/legal/terms/page_controller_addendum</a>.
                </p>
                <p>
                    Meta Platforms hat zugestimmt, die primäre Verantwortung gemäß DS-GVO für die Verarbeitung von
                    Insights-Daten zu übernehmen und sämtliche Pflichten aus der DS-GVO im Hinblick auf die Verarbeitung
                    von Insights-Daten zu erfüllen. Dies betrifft insbesondere die Art. 12 und 13 DS-GVO, Art. 15 bis 22
                    DS-GVO und Art. 32 bis 34 DSGVO.
                </p>
                <p>
                    Die uns übermittelten statistischen Informationen stellen für uns keine personenbezogenen Daten
                    (mehr) dar, so dass es uns nicht möglich ist, Sie anhand dieser Daten zu identifizieren. Die
                    Statistikdaten nutzen wir nur insofern, als dass wir allgemein die Interessen unserer Nutzer besser
                    verstehen möchten, um unsere Onlinepräsenz zu verbessern und die Qualität unserer Onlineangebote zu
                    sichern.
                </p>
                <p>
                    Soweit wir Ihre personenbezogenen Daten über unsere Instagram-Seite erheben (z.B. Ihren Namen, Ihr
                    Nickname, Inhalte der an uns geschickten Nachrichten, Kommentarinhalte sowie die von Ihnen
                    „öffentlich“ bereitgestellten Profilinformationen) nur, um mit Ihnen zu kommunizieren und zu
                    interagieren.
                </p>
                <p>
                    Ihre personenbezogenen Daten werden von uns grundsätzlich zum Zweck der Kommunikation und
                    Interaktion
                    auf der Grundlage unseres berechtigten Interesses gem. Art. 6 Abs. 1 lit. f DS-GVO verarbeitet.
                    Unser berechtigtes Interesse besteht darin, dass wir durch unsere Informations- und
                    Kommunikationsangebote auf der Instagram-Seite unsere betriebswirtschaftlichen Ziele verfolgen.
                </p>
                <p>
                    Soweit wir im Zusammenhang mit dem Betrieb unserer Instagram-Seite Verarbeitungen durchführen, für
                    die Ihre Einwilligung erforderlich ist (z.B. Teilnahme an einem Gewinnspiel, Verlosung, Versand
                    eines Newsletters, etc.), wird diese unsererseits jeweils separat eingeholt. Die Verarbeitung Ihrer
                    personenbezogenen Daten erfolgt in diesem Fall auf der Grundlage der Art. 6 Abs. 1 lit. a i.V.m.
                    Art. 7 DS-GVO.
                </p>
                <p>
                    Soweit das soziale Netzwerk Instagram bzw. der Dienstanbieter Meta Platforms ihre Daten für seine
                    eigenen Zwecke erhebt, für die eine Einwilligung erforderlich ist (z.B. Auswertung des
                    Nutzerverhaltens), erfolgt dies ebenfalls auf der Grundlage der Art. 6 Abs. 1 lit. a i.V.m. Art. 7
                    DS-GVO. In diesem Fall wird die erforderliche Einwilligung durch das soziale Netzwerk selbst
                    eingeholt.
                </p>
                <p>
                    Aufgrund der gemeinsamen Verantwortlichkeit von Meta Platforms und uns für die Verarbeitung
                    personenbezogener Daten auf unserer Instagram-Präsenz, können Sie Ihre Betroffenenrechte sowohl bei
                    uns als auch direkt bei Meta Platforms geltend machen.
                </p>
                <p>
                    Da F Meta Platforms für den überwiegenden Teil der stattfindenden Datenverarbeitung als
                    Service-Anbieter verantwortlich ist, sind unsere Möglichkeiten, auf Ihre Daten zuzugreifen, sehr
                    beschränkt. Einen Vollzugriff auf Ihre Daten hat lediglich der Service-Anbieter gemäß den
                    Nutzungsbedingungen des Netzwerks. Aus diesem Grund, kann meistens nur der Anbieter des sozialen
                    Netzwerks die notwendigen Maßnahmen zur Erfüllung Ihrer Betroffenenrechte (z.B. Recht auf Auskunft,
                    Löschung, Widerspruch, etc.) ergreifen und umsetzen. Die Geltendmachung entsprechender Rechte
                    erfolgt somit am effektivsten direkt gegenüber dem Netzwerk-Anbieter.
                </p>
                <p>
                    Bitte beachten Sie, dass personenbezogene Daten durch Meta Platforms auch in den USA verarbeitet
                    werden.<br>
                </p>
                <p>
                    <br>
                    <strong>§ 13</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>Ihre Rechte</strong>
                </p>
                <p>
                    Sie haben gemäß Art. 15 DS-GVO das Recht, Auskunft über Ihre von uns verarbeiteten personenbezogenen
                    Daten zu verlangen. Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der
                    von Ihnen verarbeiteten personenbezogenen Daten, die Kategorien von Empfängern, gegenüber denen Ihre
                    Daten offengelegt wurden oder werden, die geplante Speicherdauer, das Bestehen der Rechte auf
                    Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch, das Bestehen eines
                    Beschwerderechts bei einer Aufsichtsbehörde, die Herkunft ihrer Daten, sofern diese nicht bei uns
                    erhoben wurden, sowie über das Bestehen einer automatisierten Entscheidungsfindung einschließlich
                    Profiling und ggf. aussagekräftigen Informationen zu deren Einzelheiten verlangen.
                </p>
                <p>
                    Sie haben gemäß Art. 16 DS-GVO das Recht, unverzüglich die Berichtigung unrichtiger oder die
                    Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen.
                </p>
                <p>
                    Sie haben gemäß Art. 17 DS-GVO das Recht, die Löschung Ihrer bei uns gespeicherten personenbezogenen
                    Daten zu verlangen, soweit nicht eine Rechtsgrundlage besteht, die uns zur weiteren Speicherung der
                    Daten berechtigt oder verpflichtet.
                </p>
                <p>
                    Sie haben gemäß Art. 18 DS-GVO das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
                    Daten zu verlangen, wenn<br>
                    • die Richtigkeit der personenbezogenen Daten von Ihnen bestritten wird, und zwar für eine Dauer,
                    die es uns ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen,<br>
                    • die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten ablehnen und
                    stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangen,<br>
                    • wir die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigen, Sie die
                    Daten jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen,<br>
                    • Sie Widerspruch gegen die Verarbeitung gemäß Artikel 21 Abs. 1 DS-GVO eingelegt haben, solange
                    noch nicht feststeht, ob unsere berechtigten Gründe gegenüber Ihren Gründen überwiegen.
                </p>
                <p>
                    Sie haben gemäß Art. 20 DS-GVO das Recht, Ihre personenbezogenen Daten, die Sie uns bereitgestellt
                    haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten oder die
                    Übermittlung an einen anderen Verantwortlichen zu verlangen.
                </p>
                <p>
                    Sie haben gemäß Art. 77 DS-GVO das Recht, sich bei einer Aufsichtsbehörde zu beschweren, wenn Sie
                    der
                    Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DS-GVO
                    verstößt.
                </p>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/datenschutz',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: '',
    subTitle: '',
};
</script>
